import { useEffect, useState, type RefObject } from 'react'

import {
  heroPhase,
  onPhaseChange,
  type HeroPhase,
} from '~/widgets/CostBomDemo/engine/heroEngine'

/** The engine's current phase for the hero section behind `heroRef`. */
export function useHeroPhase(
  heroRef: RefObject<HTMLElement | null>,
): HeroPhase {
  const [phase, setPhase] = useState<HeroPhase>('idle')

  useEffect(() => {
    const hero = heroRef.current
    if (!hero) return () => {}
    setPhase(heroPhase(hero))
    return onPhaseChange(hero, setPhase)
  }, [heroRef])

  return phase
}
